import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { P360Profiles } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'

import { ILandingPartner } from 'partner360/models/landing/ILandingPartner'
import { ILandingPartnerFromSearch } from 'partner360/models/landing/ILandingPartnerFromSearch'

export const mapLandingPartnerFromSearchToLandingPartner = (
  partner: ILandingPartnerFromSearch
): ILandingPartner => {
  const profilesJson = parseJson<P360Profiles[]>(partner.ProfilesJSON) || []
  return {
    ...partner,
    PartnerId: partner.PartnerID,
    LocationId: partner.LocationID,
    ProfilesJSON: profilesJson,
    STRequestId: null,
    STRequestStatus: null,
    STRequestAction: 'Add',
    RTM: partner.RTM,
  }
}
